import React from 'react';
import { XIcon } from 'lucide-react';
interface ContactModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function ContactModal({
  isOpen,
  onClose
}: ContactModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center" data-id="element-16">
      <div className="bg-white rounded-lg shadow-xl relative" data-id="element-17">
        <button onClick={onClose} className="absolute -right-3 -top-3 bg-white rounded-full p-1.5 shadow-lg text-gray-500 hover:text-gray-700 transition-colors z-[60]" aria-label="Close contact form" data-id="element-18">
          <XIcon size={20} data-id="element-19" />
        </button>
        <div className="w-[350px] h-[820px] relative max-w-full" data-id="element-20">
          <iframe src="https://forms.vagaro.com/FormResponse/nIXEssosr806g0r1urPFrbBrvbaTE2umzNZQ8V2yivS?embeded=true" className="absolute inset-0 w-full h-[820px] rounded-lg" frameBorder="0" marginWidth="0" marginHeight="0" title="Contact Form" data-id="element-21">
            Loading...
          </iframe>
        </div>
      </div>
    </div>;
}